module.exports = __webpack_public_path__ + "static/img/1.bc68a51.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/sp/1.png
// module id = 3fTF
// module chunks = 0